import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SafeReactPaginate from '../General/SafeReactPaginate';
import { limpiarFiltros } from '../../actions/generalActios';
import { fetchSellersFilter } from '../../actions/sellersActions';
import { fetchOrdenesEncabezado, setFiltroOrdenes, resetOrdenes, getFacturaOrdenes } from '../../actions/ordenesActions';
import OrdenListItem from './OrdenListItem';
import FiltroOrdenes from './FiltroOrdenes';
import BigSpinner from "../General/BigSpinner";
import { filtroUnaSemana } from '../../utilities/fechasFiltro';
import { formatoDecimal } from '../../utilities/formatoNumeros';
import { withNavigation } from '../General/withNavigation';
import UploadFileOrdenes from '../General/UploadFileOrdenes';
import { base64ToArrayBuffer, fileToBase64, saveByteArray } from '../../utilities/formatFile';
import { postCargaMasivaComprobantesApi } from '../../api/axios';
import { hasAnyValidComprobanteInEstados, isProbablyPdfBase64 } from '../../helper/comprobanteHelper';
import { toast } from '../../utilities/appToast';
import PropTypes from 'prop-types';
import '../Publicaciones/Components/PublicacionStyles.css';
import './OrdenesStyles.css';

const fechaFiltro = filtroUnaSemana();

// Wrapper para usar hooks en class component
function ListOrdenesWrapper(props) {
    const navigate = useNavigate();
    return <ListOrdenes {...props} navigate={navigate} />;
}

class ListOrdenes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            onFilter: typeof window === 'undefined' || window.innerWidth >= 768,
            comprobantesDisponibles: {},
            request: {
                idSeller: this.props.idSeller,
                numeroPagina: this.props.numeroPagina ? this.props.numeroPagina : 1,
                cantidadPagina: 10,
                documento: "",
                idOrden: "",
                nombre: "",
                apellido: "",
                fechaDesde: fechaFiltro.desde,
                fechaHasta: fechaFiltro.hasta,
                skuMarket: "",
                desdePublicacion: false
            }
        };
        const { isCategory, isSoloLectura, isAdminMod } = this.props.userType;
        this.allowSearchBySeller = isCategory || isSoloLectura || isAdminMod;
        this.lastPrecargaKey = null;
    }

    buildPrecargaKey = (ordenesData) => {
        const elementos = Array.isArray(ordenesData?.elementos) ? ordenesData.elementos : [];
        if (elementos.length === 0) return "";
        return elementos
            .map((o) => {
                const id = o?.idOrden ?? "";
                const idEstado = o?.estado?.[0]?.idEstado ?? o?.estado?.[0]?.IdEstado ?? "";
                return `${id}:${idEstado}`;
            })
            .join("|");
    }

    ensurePrecargaComprobantes = (ordenesData) => {
        const key = this.buildPrecargaKey(ordenesData);
        if (!key || key === this.lastPrecargaKey) return;
        this.lastPrecargaKey = key;
        this.precargarComprobantes(ordenesData);
    }

    componentDidMount() {
        // Only use cached data if NO custom filter is active.
        // If coming from Dashboard (emptyFiltro.ordenes = false), we must fetch.
        if (this.props.ordenes?.elementos?.length > 0 && this.props.emptyFiltro.ordenes) {
            this.ensurePrecargaComprobantes(this.props.ordenes);
            return;
        }

        let estadoInicioFiltraPor_Moderador = { ...this.state.request, idSeller: "" };
        let request = this.props.filtro;

        if (this.props.emptyFiltro.ordenes) {
            //Si el filtro de ordenes esta vacio, pero en this.propos.filtro tengo el skuMarket,
            //es porque vengo de seleccionar una publicacion para ver sus ordenes

            if (request.desdePublicacion) {
                // vengo con un skuMarket desde Publicaciones
                this.setState({ onFilter: false })
                request = this.state.request;
                request.idSeller = "";
                request.numeroPagina = 1;
                request.skuMarket = this.props.filtro.skuMarket;
                request.fechaDesde = this.props.filtro.fechaDesde;
                request.desdePublicacion = this.props.filtro.desdePublicacion;

                this.props.setFiltroOrdenes(request);
                this.setState({ request: request });
                this.props.fetchOrdenesEncabezado(request);

            } else if (this.allowSearchBySeller) {
                estadoInicioFiltraPor_Moderador.desdePublicacion = false;
                this.props.setFiltroOrdenes(estadoInicioFiltraPor_Moderador);
                this.setState({ request: estadoInicioFiltraPor_Moderador })
                this.props.fetchOrdenesEncabezado(estadoInicioFiltraPor_Moderador);
            } else {
                this.props.setFiltroOrdenes(this.state.request);
                this.props.fetchOrdenesEncabezado(this.state.request);
            }

        } else {

            request.numeroPagina = 1;
            this.props.setFiltroOrdenes(request);
            this.setState({ request: request });
            this.props.fetchOrdenesEncabezado(request);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.ordenes !== this.props.ordenes) {
            this.ensurePrecargaComprobantes(this.props.ordenes);
            return;
        }

        const prevKey = this.buildPrecargaKey(prevProps.ordenes);
        const currKey = this.buildPrecargaKey(this.props.ordenes);
        if (prevKey !== currKey) {
            this.ensurePrecargaComprobantes(this.props.ordenes);
        }
    }

    getCurrentEstadoId = (orden) => {
        const idEstado = orden?.estado?.[0]?.idEstado ?? orden?.estado?.[0]?.IdEstado;
        const parsed = Number(idEstado);
        return Number.isFinite(parsed) ? parsed : null;
    }

  precargarComprobantes = async (ordenesData) => {
    const elementos = Array.isArray(ordenesData?.elementos) ? ordenesData.elementos : [];
    if (elementos.length === 0) return;

    await Promise.all(elementos.map(async (orden) => {
      const idOrden = orden?.idOrden;
      const idEstado = this.getCurrentEstadoId(orden);
      if (!idOrden || !idEstado) return;

      if (hasAnyValidComprobanteInEstados(orden)) {
        this.setState((prev) => ({
          comprobantesDisponibles: { ...prev.comprobantesDisponibles, [idOrden]: true }
        }));
        return;
      }

      try {
        const archivo = await getFacturaOrdenes(idOrden, idEstado);
        if (isProbablyPdfBase64(archivo)) {
          this.setState((prev) => ({
            comprobantesDisponibles: { ...prev.comprobantesDisponibles, [idOrden]: true }
          }));
          return;
        }
        throw new Error();
      } catch {
        this.setState((prev) => (
          prev.comprobantesDisponibles?.[idOrden] === true
            ? {}
            : { comprobantesDisponibles: { ...prev.comprobantesDisponibles, [idOrden]: false } }
        ));
      }
    }));
  }

  descargarComprobanteOrden = async (orden) => {
    const idOrden = orden?.idOrden;
    const idEstado = this.getCurrentEstadoId(orden);
    if (!idOrden || !idEstado) {
      toast.error("No se pudo determinar el comprobante de la orden");
      return;
    }

    try {
      const archivo = await getFacturaOrdenes(idOrden, idEstado);
      const pdfData = base64ToArrayBuffer(archivo);
      saveByteArray("Comprobante", pdfData);
      toast.success("Descarga realizada");
    } catch {
      toast.error("No hay comprobante disponible para descargar")
    }
  }

  onOrden = (id) => {

    let pathReturn = `/Ordenes`


    this.props.navigate({
      pathname: `/Ordenes/Editar/${id}`,
      state: pathReturn
    });
  }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;

        const updatedFiltro = {
            ...this.props.filtro,
            numeroPagina: selectedPage,
        };

        this.props.setFiltroOrdenes(updatedFiltro);
        this.props.fetchOrdenesEncabezado(updatedFiltro);
    };

    updateRequest = (request) => {
        if (!this.allowSearchBySeller) {
            request.idSeller = null;
        }

        this.setState({ request: request, currentPage: request.numeroPagina });
        this.props.setFiltroOrdenes(request);
        this.props.fetchOrdenesEncabezado(request);
    }

    goToPreviousPath = () => {
        this.props.resetOrdenes();
        const { pathReturn } = this.props.location.state;
        this.props.navigate(`${pathReturn}`);
    }

    updateFile = async (file, idSellerOrden, idOrden) => {
        if (!file) {
            return;
        }

        const idSeller = idSellerOrden != null && idSellerOrden !== ''
            ? idSellerOrden
            : this.props.idSeller;
        const normalizedIdOrden = idOrden != null && String(idOrden).trim() !== ''
            ? String(idOrden).trim()
            : '';

        if (idSeller == null || idSeller === '') {
            toast.error('No se pudo determinar el seller de la orden para la carga del comprobante.');
            return;
        }

        if (!normalizedIdOrden) {
            toast.error('No se pudo determinar la orden para la carga del comprobante.');
            return;
        }

        const base64 = await fileToBase64(file);
        this.setState({ comprobantesZip: base64 });

        let request = {
            idSeller: idSeller,
            fileName: `${normalizedIdOrden}.pdf`,
            fileContent: base64
        };

        postCargaMasivaComprobantesApi(request)
        .then((response) => {
            const hasErrors = response.data?.HasErrors;
            const totalOk = response.data?.ProcesadosOk;
            const totalError = response.data?.ProcesadosConError;

            if (hasErrors) {
                toast.warning(`Carga completada: ${totalOk} ok, ${totalError} con error`);
                if (Array.isArray(response.data?.Errors)) {
                    response.data.Errors.forEach(err => {
                        const mensaje = err.IdOrden
                            ? `Orden ${err.IdOrden}: ${err.ErrorMesage}`
                            : err.ErrorMesage;
                        toast.error(mensaje);
                    });
                }
            } else {
                toast.success(`Comprobante cargado para la orden ${normalizedIdOrden}`);
            }
            this.setState((prev) => ({
                comprobantesDisponibles: {
                    ...prev.comprobantesDisponibles,
                    [normalizedIdOrden]: true,
                    [idOrden]: true
                }
            }));
        })
        .catch((error) => {
            const errores = error?.response?.data?.errors;

            if (Array.isArray(errores)) {
                errores.forEach(err => {
                    // Si err es un objeto con idOrden y errorMesage
                    if (typeof err === 'object' && err.errorMesage && err.idOrden) {
                        toast.error(`Orden ${err.idOrden}: ${err.errorMesage}`);
                    } else if (typeof err === 'object' && err.errorMesage) {
                        // Solo tiene errorMesage
                        toast.error(err.errorMesage);
                    } else if (typeof err === 'string') {
                        // Si err es un string simple
                        toast.error(err);
                    } else {
                        toast.error(JSON.stringify(err));
                    }
                });
            } else if (error?.response?.status === 400) {
                toast.error("Solicitud inválida. Verifica los datos del archivo.");
            } else {
                toast.error("Error al subir el archivo. Archivo inválido");
            }

            this.setState((prev) => ({
                comprobantesDisponibles: {
                    ...prev.comprobantesDisponibles,
                    [normalizedIdOrden]: false,
                    [idOrden]: false
                }
            }));
        });
    };

    render() {
        const { userType, ordenes, loadingOrdenes } = this.props;
        const { isAdminMod, isCategory, isSoloLectura } = userType;
        const showCargaComprobanteLista = (isCategory || isAdminMod) && !isSoloLectura;
        const elementos = Array.isArray(ordenes?.elementos) ? ordenes.elementos : [];
        const visibleOrdenes = elementos.filter((orden) => (
            (this.props.idSeller === orden?.seller?.codigo && !isAdminMod) ||
            isCategory || isAdminMod || isSoloLectura
        ));
        const pageCount = Math.max(0, Math.ceil((Number(this.props.ordenes?.cantidadTotal) || 0) / 10));
        const forcePageRaw = (Number(this.props.filtro?.numeroPagina) || 1) - 1;
        const safeForcePage = Math.min(Math.max(forcePageRaw, 0), Math.max(pageCount - 1, 0));

        const totalizadores = [
            {
                nombre: 'Total Ventas',
                valor: '$' + formatoDecimal(ordenes.montoVentasTotal ?? 0),
                styleClass: 'ordenes-resumen-stats__cell--ventas',
                valueClass: 'ordenes-resumen-stats__value--ventas'
            },
            {
                nombre: 'Total Ventas Anuladas',
                valor: '$' + formatoDecimal(ordenes.montoTotalVentasAnuladas ?? 0),
                styleClass: 'ordenes-resumen-stats__cell--anuladas',
                valueClass: 'ordenes-resumen-stats__value--anuladas'
            },
            {
                nombre: 'Total Comisión',
                valor: '$' + formatoDecimal(ordenes.montoComisionTotal ?? 0),
                styleClass: 'ordenes-resumen-stats__cell--comision',
                valueClass: 'ordenes-resumen-stats__value--comision'
            },
            {
                nombre: 'Cantidad Órdenes',
                valor: ordenes.cantidadTotal ?? 0,
                styleClass: 'ordenes-resumen-stats__cell--cantidad',
                valueClass: 'ordenes-resumen-stats__value--cantidad'
            },
        ]


        return (
            <div className="container py-2 pub-catalog">
                <header className="pub-catalog__mast">
                    <div className="pub-catalog__intro">
                        <p className="pub-catalog__kicker">Gestión</p>
                        <h4 className="pub-catalog__title">Órdenes</h4>
                        <p className="pub-catalog__subtitle">Ventas, comisiones y estados de orden.</p>
                    </div>

                    <div className="pub-catalog__metrics-wrap">
                        {!isSoloLectura &&
                            <div className="list-group list-group-horizontal-md ordenes-resumen-stats">
                                {totalizadores.map((totalizador) => {
                                    return (
                                        <div key={totalizador.nombre} className={`list-group-item text-center border-0 ordenes-resumen-stats__cell ${totalizador.styleClass}`}>
                                            <span className="font-size-073rem d-block pb-1 ordenes-resumen-stats__label">{totalizador.nombre}</span>
                                            <span className={`ordenes-resumen-stats__value ${totalizador.valueClass}`}>{totalizador.valor ?? 0}</span>
                                        </div>
                                    )
                                })
                                }
                            </div>
                        }
                    </div>

                    {this.props.filtro.desdePublicacion &&
                        <button
                            type="button"
                            onClick={this.goToPreviousPath}
                            className="ord-catalog__back"
                        >
                            <i className="fa fa-arrow-left" aria-hidden="true" /> Volver
                        </button>
                    }
                </header>

                <div hidden={!this.state.onFilter}>
                    <FiltroOrdenes
                        filtro={this.props.filtro}
                        updateRequest={this.updateRequest}
                        allowSearchBySeller={isCategory || isSoloLectura || isAdminMod}
                        onMinimize={this.props.filtro.desdePublicacion ? null : () => this.setState({ onFilter: false })}
                    />
                </div>

                {!this.props.filtro.desdePublicacion && !this.state.onFilter && (
                    <button
                        type="button"
                        className="pub-catalog__filter-open"
                        onClick={() => this.setState({ onFilter: true })}
                        aria-expanded={false}
                    >
                        <span className="pub-catalog__filter-open-icon" aria-hidden="true">
                            <i className="fa fa-filter" />
                        </span>
                        <span className="pub-catalog__filter-open-copy">
                            <strong>Abrir filtros</strong>
                            <small>Orden, cliente, estado y período</small>
                        </span>
                        <i className="fa fa-chevron-down pub-catalog__filter-open-chevron" aria-hidden="true" />
                    </button>
                )}

                {loadingOrdenes ? <BigSpinner message="Cargando ordenes de sellers..." /> :
                    <div>
                        {visibleOrdenes.length > 0 ?
                            <div className="list-group pub-catalog__list">
                                {visibleOrdenes.map((orden, index) => {
                                    const idSellerOrden = orden.seller?.codigo;
                                    const comprobanteDisponible =
                                        this.state.comprobantesDisponibles?.[orden.idOrden] === true;
                                    const uploadColumn = (
                                        <div
                                            className="ord-upload"
                                            onClick={(e) => e.stopPropagation()}
                                            onMouseDown={(e) => e.stopPropagation()}
                                        >
                                            {!comprobanteDisponible ? (
                                                <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <UploadFileOrdenes
                                                        inputId={`upload-orden-${orden.idOrden}`}
                                                        acceptType=".pdf"
                                                        onFileLoaded={(f) => this.updateFile(f, idSellerOrden, orden.idOrden)}
                                                        style={{
                                                            width: '100%',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="ord-upload__download"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        this.descargarComprobanteOrden(orden);
                                                    }}
                                                >
                                                    <i className="mdi mdi-arrow-down-bold me-1" />
                                                    Descargar comprobante
                                                </button>
                                            )}
                                        </div>
                                    );
                                    const readOnlyDownloadColumn = comprobanteDisponible ? (
                                        <div
                                            className="ord-upload"
                                            onClick={(e) => e.stopPropagation()}
                                            onMouseDown={(e) => e.stopPropagation()}
                                        >
                                            <button
                                                type="button"
                                                className="ord-upload__download"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.descargarComprobanteOrden(orden);
                                                }}
                                            >
                                                <i className="mdi mdi-arrow-down-bold me-1" />
                                                Descargar comprobante
                                            </button>
                                        </div>
                                    ) : null;

                                    if (this.props.idSeller === orden?.seller?.codigo && !isAdminMod) {
                                        return (
                                            <div key={orden?.idOrden ?? index} className="ord-list-row" onClick={(e) => { if (e.target.tagName !== 'INPUT') this.onOrden(orden?.idOrden) }}>
                                                {isSoloLectura ? readOnlyDownloadColumn : uploadColumn}

                                                <div style={{ flex: '1 1 0', minWidth: 0 }}>
                                                    <OrdenListItem
                                                        mailCliente={""}
                                                        idOrden={orden.idOrden}
                                                        idReferencia={orden.idReferencia}
                                                        seller={orden.seller.descripcion}
                                                        fecha={orden.fecha}
                                                        cliente={orden.cliente.nombre + ' ' + orden.cliente.apellido}
                                                        documento={orden.cliente.documento}
                                                        tipoEntrega={orden.entrega.tipoEntrega.descripcion}
                                                        montoVenta={orden.montoVenta}
                                                        productos={orden.productos}
                                                        estado={orden.estado}
                                                        cuotas={orden.pago?.cuotas}
                                                        tarjeta={orden.pago?.tarjeta}
                                                        urlLogo={orden.seller.urlLogo}
                                                        anulacionMegatone={orden.anulacionMegatone}
                                                        showComision={false}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    } else if (showCargaComprobanteLista) {
                                        return (
                                            <div key={orden.idOrden ?? index} className="ord-list-row">
                                                {isSoloLectura ? readOnlyDownloadColumn : uploadColumn}
                                                <div style={{ flex: '1 1 0', minWidth: 0 }}>
                                                    <button
                                                        type="button"
                                                        onClick={() => { this.onOrden(orden.idOrden) }}
                                                        className="btn btn-link p-0 m-0 text-start w-100 text-decoration-none"
                                                        style={{ color: 'inherit', minWidth: 0 }}
                                                    >
                                                        <OrdenListItem
                                                            idOrden={orden.idOrden}
                                                            idReferencia={orden.idReferencia}
                                                            seller={orden.seller?.descripcion}
                                                            fecha={orden.fecha}
                                                            cliente={orden.cliente?.nombre + ' ' + orden.cliente?.apellido}
                                                            mailCliente={orden.cliente?.email}
                                                            documento={orden.cliente?.documento}
                                                            tipoEntrega={orden.entrega?.tipoEntrega?.descripcion}
                                                            montoVenta={orden.montoVenta}
                                                            productos={orden.productos}
                                                            estado={orden.estado}
                                                            cuotas={orden.pago?.cuotas}
                                                            tarjeta={orden.pago?.tarjeta}
                                                            urlLogo={orden.seller?.urlLogo}
                                                            dniIdBocaSeller={orden.idVendedorBoca}
                                                            plataformaCodigo={orden.plataforma?.codigo}
                                                            importeComision={orden.montoComision}
                                                            anulacionMegatone={orden.anulacionMegatone}
                                                            showComision={true}
                                                        />
                                                    </button>
                                                </div>
                                            </div>
                                        )
                                    } else if (isCategory || isAdminMod || isSoloLectura) {
                                        return (
                                            <div key={orden.idOrden ?? index} className="ord-list-row">
                                                {isSoloLectura && readOnlyDownloadColumn}
                                                <button
                                                    type="button"
                                                    onClick={() => { this.onOrden(orden.idOrden) }}
                                                    className="btn btn-link p-0 m-0 text-start w-100 text-decoration-none"
                                                    style={{ flex: '1 1 0', minWidth: 0, color: 'inherit' }}
                                                >
                                                    <OrdenListItem
                                                        idOrden={orden.idOrden}
                                                        idReferencia={orden.idReferencia}
                                                        seller={orden.seller?.descripcion}
                                                        fecha={orden.fecha}
                                                        cliente={orden.cliente?.nombre + ' ' + orden.cliente?.apellido}
                                                        mailCliente={orden.cliente?.email}
                                                        documento={orden.cliente?.documento}
                                                        tipoEntrega={orden.entrega?.tipoEntrega?.descripcion}
                                                        montoVenta={orden.montoVenta}
                                                        productos={orden.productos}
                                                        estado={orden.estado}
                                                        cuotas={orden.pago?.cuotas}
                                                        tarjeta={orden.pago?.tarjeta}
                                                        urlLogo={orden.seller?.urlLogo}
                                                        dniIdBocaSeller={orden.idVendedorBoca}
                                                        plataformaCodigo={orden.plataforma?.codigo}
                                                        importeComision={orden.montoComision}
                                                        anulacionMegatone={orden.anulacionMegatone}
                                                        showComision={true}
                                                    />
                                                </button>
                                            </div>
                                        )
                                    }
                                    return null;
                                })
                                }
                            </div>
                            :
                            <div className="pub-catalog__empty">
                                <i className="ti-package" aria-hidden="true" />
                                <p>No se encontraron resultados</p>
                            </div>
                        }
                    </div>
                }

                <div className="d-flex justify-content-center">
                    <SafeReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={5}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={safeForcePage}
                    />
                </div>
            </div>
        );
    }
}
ListOrdenes.propTypes = {
    // Hooks props
    navigate: PropTypes.func,
    location: PropTypes.shape({
        state: PropTypes.shape({
            pathReturn: PropTypes.string,
        }),
    }),
    // Redux props
    idSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    numeroPagina: PropTypes.number,
    userType: PropTypes.shape({
        isSoloLectura: PropTypes.bool,
        isAdminMod: PropTypes.bool,
        isCategory: PropTypes.bool,
    }),
    ordenes: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        elementos: PropTypes.array,
        montoVentasTotal: PropTypes.number,
        montoTotalVentasAnuladas: PropTypes.number,
        montoComisionTotal: PropTypes.number,
        cantidadTotal: PropTypes.number
    })]),
    emptyFiltro: PropTypes.shape({
        ordenes: PropTypes.bool,
    }),
    filtro: PropTypes.shape({
        desdePublicacion: PropTypes.bool,
        idSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        numeroPagina: PropTypes.number,
        skuMarket: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        fechaDesde: PropTypes.string,
        fechaHasta: PropTypes.string,
    }),
    loadingOrdenes: PropTypes.bool,
    // Actions props
    setFiltroOrdenes: PropTypes.func,
    fetchOrdenesEncabezado: PropTypes.func,
    resetOrdenes: PropTypes.func,
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    idSeller: state.general.idSeller,
    loadingOrdenes: state.ordenes.loadingOrdenes,
    emptyFiltro: state.general.limpiar,
    ordenes: state.ordenes.ordenes,
    filtro: state.ordenes.filtro
});

export default withNavigation(connect(mapStateToProps, {
    fetchOrdenesEncabezado,
    limpiarFiltros,
    setFiltroOrdenes,
    fetchSellersFilter,
    resetOrdenes,
})(ListOrdenesWrapper));
